<template>
    <div id="progress" class="text-center page">
        <h2>Deze pagina is nog in ontwikkeling.</h2>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>
</style>